import {Label} from '@/base/ui/label'
import {Textarea} from '@/base/ui/textarea'
import {cn, getLabelPositionClass, randomId} from '@/lib/utils'
import React from 'react'

export interface IWuTextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string
  variant?: 'flat' | 'outlined'
  readonly?: boolean
  labelPosition?: 'left' | 'top' | 'right'
}

export const WuTextarea = React.forwardRef<
  HTMLTextAreaElement,
  IWuTextareaProps
>((props, ref) => {
  const {
    label,
    id = randomId(),
    variant = 'flat',
    readonly,
    maxLength,
    labelPosition = 'top',
    ...rest
  } = props

  const handleOnChange = (e: React.ChangeEvent<HTMLTextAreaElement>): void => {
    if (rest.onChange) rest.onChange(e)
  }

  const customLabelPosition = getLabelPositionClass(labelPosition)

  return (
    <div
      className={cn(customLabelPosition, 'flex wu-textarea-container')}
      dir={rest.dir}
    >
      <Textarea
        {...rest}
        ref={ref}
        id={id}
        className={cn(
          'peer rounded-t-sm',
          variant === 'outlined' ? 'border border-gray-subtle' : '',
          rest.className,
        )}
        onChange={handleOnChange}
        readOnly={readonly}
        maxLength={maxLength}
      />
      {label && (
        <Label
          htmlFor={id}
          className={cn(
            (labelPosition === 'left' || labelPosition === 'right') && 'mt-1.5',
            'text-sm font-normal leading-6 text-gray-lead whitespace-nowrap  truncate max-w-[120px] wu-textarea-label',
          )}
        >
          {label}
        </Label>
      )}
    </div>
  )
})

WuTextarea.displayName = 'WuTextarea'
